export default {
  primary: "#101966",
  gray: {
    base: "#9e9e9e",
    lighten5: "#fafafa",
    lighten4: "#f5f5f5",
    lighten3: "#eeeeee",
    lighten2: "#e0e0e0",
    lighten1: "#bdbdbd",
    darken1: "#757575",
    darken2: "#616161",
    darken3: "#424242",
    darken4: "#212121",
  },
  blue: {
    base: "#1976D2",
    lighten5: "#E3F2FD",
    darken4: "#0D47A1",
  },
  error: {
    base: "#FF5252",
  },
};
